const UIStaticText = {
  en: {
    inputFormNameLabel: 'Form Name',
    inputFormDescriptionLabel: 'Form Description',
    inputFormTranslationLabel: 'Add New Translation',
    inputFormExistingTranslationsLabel: 'Existing Translations',
    inputFormDefaultLanguageLabel: 'Default Language',
    formTabPane: 'Edit Form',
    formTranslationPane: 'Translations',
    previewTabPane: 'Preview',
    questionCount: 'Questions',
    questionGroupCount: 'Question Groups',
    mandatoryQuestionCount: 'Mandatory Questions',
    version: 'Version',
    inputQuestionGroupNameLabel: 'Question Group Name',
    inputQuestionGroupLabelLabel: 'Question Group Label',
    inputQuestionGroupDescriptionLabel: 'Question Group Description',
    inputRepeatThisGroupCheckbox: 'Repeat this group',
    inputRepeatTextLabel: 'Repeat Text',
    buttonShowQuestionsText: 'Show Questions',
    buttonHideQuestionsText: 'Hide Questions',
    buttonEditGroupText: 'Edit Group',
    buttonCancelEditGroupText: 'Cancel Edit Group',
    buttonDeleteText: 'Delete',
    buttonCancelText: 'Cancel',
    buttonAddNewQuestionGroupText: 'Insert group here',
    buttonCopyQuestionGroupText: 'Copy group here',
    buttonMoveQuestionGroupText: 'Move group here',
    buttonAddNewQuestionText: 'Add new question',
    buttonCopyQuestionText: 'Copy question here',
    buttonMoveQuestionText: 'Move question here',
    inputQuestionLabelLabel: 'Question Label',
    inputQuestionNameLabel: 'Question Name',
    inputQuestionTypeLabel: 'Question Type',
    inputQuestionVariableNameLabel: 'Variable Name',
    inputQuestionTooltipLabel: 'Question Tooltip',
    inputQuestionRequiredCheckbox: 'Required',
    inputQuestionMetaCheckbox: 'Data point name',
    inputQuestionMetaCheckboxHint:
      'A string value that represents the name of the data point',
    buttonSaveText: 'Save',
    questionSettingTabPane: 'Setting',
    questionSkipLogicTabPane: 'Skip Logic',
    questionCustomParamsTabPane: 'Custom Params',
    questionExtraTabPane: 'Extra',
    inputQuestionDependentToLabel: 'Dependent to Question',
    inputQuestionDependentLogicLabel: 'Logic',
    inputQuestionDependentAnswerLabel: 'Value',
    questionMoreInputTypeSettingText: 'More Input Question Setting',
    inputQuestionRequireDoubleEntryCheckbox: 'Require double entry of answer',
    inputQuestionHiddenStringCheckbox: 'Hidden String/Password',
    questionMoreInputNumberSettingText: 'More Number Question Setting',
    inputQuestionAllowDecimalCheckbox: 'Allow Decimal',
    inputQuestionMinimumValueLabel: 'Minimum Value',
    inputQuestionMaximumValueLabel: 'Maximum Value',
    inputQuestionMinimumValidationText: 'Min value must be less than',
    inputQuestionMaximumValidationText: 'Max value must be greater than',
    inputQuestionEqualValueLabel: 'Equal Value',
    questionMoreOptionTypeSettingText: 'More Option Question Setting',
    questionMoreOptionTranslationText: 'Option Translations',
    inputQuestionAllowOtherCheckbox: 'Allow Other',
    inputQuestionAllowOtherTextLabel: 'Allow Other Text',
    inputQuestionOptionNameLabel: 'Option',
    questionMoreTreeSettingText: 'More Nested List Question Setting',
    inputSelectTreeDropdownValueLabel: 'Select Nested List Value',
    deleteQuestionGroupError: 'Unable to delete question group',
    deleteQuestionError: 'Unable to delete question',
    infoNoDependentQuestionText: 'No dependent questions',
    questionMoreCascadeSettingText: 'More Cascade Question Setting',
    inputQuestionEndpointLabel: 'Cascade Endpoint',
    inputQuestionEndpointValidationText: 'Invalid URL',
    inputQuestionInitialValueLabel: 'Initial Value',
    inputQuestionListCheckbox: 'Use Specific Object Name',
    inputQuestionListLabel: 'Object Name',
    questionMoreInputDateSettingText: 'More Date Question Setting',
    inputQuestionAfterDateValueLabel: 'After Date',
    inputQuestionBeforeDateValueLabel: 'Before Date',
    alertDeleteQuestionTitle: 'Delete Question',
    alertDeleteQuestion: 'Do you want to delete this question?',
    alertDeleteQuestionGroupTitle: 'Delete Question Group',
    alertDeleteQuestionGroup:
      'Do you want to delete this question group and all the questions?',
    questionMoreTableTypeSettingText: 'More Table Question Setting',
    inputColumnNameLabel: 'Column Name',
    inputColumnTypeLabel: 'Column Type',
    inputColumnOptionsLabel: 'Column Options',
    questionTableTypeDefineOptionsText: 'Define Options',
    questionHintSettingText: 'Hint Setting',
    inputQuestionStaticValueLabel: 'Static Value',
    inputSelectHintEndpointLabel: 'Hint Endpoint',
    inputSelectHintPathLabel: 'Hint Path',
    inputQuestionHintButtonTextLabel: 'Hint Button Text',
    questionMoreImageTypeSettingText: 'More Image Question Setting',
    inputQuestionImageLimitValidationText: 'Limit / Max file size',
    questionMoreAutofieldTypeSettingText: 'More Autofield Question Setting',
    inputQuestionAutofieldMultiline: 'Support Multiline Function',
    inputQuestionAutofieldFnString: 'Add Function (String) Here',
    inputQuestionAutofieldFnColor: 'Add Function Color Here',
    questionStatsSettingTest: 'Stats Setting',
    inputStatsUrlText: 'Add Stats Endpoint Here',
    inpuStatsUrlValidationText: 'Invalid URL format',
    questionIdText: 'Question ID',
    copyQuestionIdToClipboardText: 'Copy Question ID',
    copiedText: 'Copied',
    validationErrorTitle: 'Validation Error',
    validationErrorDescription:
      'Please fix all validation before save the form.',
    inputQuestionShortLabelLabel: 'Short Label',
    inputQuestionShortLabelTooltip:
      'The value entered in the Sort Label field will be used as a replacement for the question label in the Excel export.',
    inputQuestionDisplayOnlyCheckbox: 'Display Only',
    inputQuestionDisplayOnlyCheckboxTooltip:
      'If you check "Display Only", the answer value for this question will not be submitted.',
    evaluatefnStringButton: 'Evaluate Function',
    evaluatefnStringError: 'Error evaluating function string',
    evaluatefnStringSuccess: 'Function string evaluated correctly!',
    prefilledQuestionTitle: 'Would you like to add a prefill to this question?',
    prefilledYesText: 'Yes',
    prefilledNoText: 'No',
    prefilledSourceQuestion: 'Source Question',
    prefilledSQPlaceholder: 'Select source question',
    prefilledSourceAnswer: 'Source Answer',
    prefilledSAPlaceholder: 'Select source answer',
    prefilledDefaultValue: 'Default Value',
    prefilledDVPlaceholder: 'Select default value',
    addonBefore: 'AddonBefore',
    addonBeforePlaceholder: 'e.g., +62 or other required prefixes',
    addonAfter: 'AddonAfter',
    addonAfterPlaceholder:
      'e.g., Kilogram, Unit, or any other necessary suffix.',
    inputLeadingQuestionLabel: 'Leading Question',
    inputShowRepeatInQuestionLevelCheckbox: 'Show Repeat in Question Level',
    inputQuestionDisabledCheckbox: 'Disabled',
    inputQuestionIsRepeatIdentifierCheckbox: 'Repeat Identifier',
    inputDependencyRuleLabel: 'Dependency Rule',
    questionMoreGeoSettingText: 'Set the default map center (optional)',
    inputGeoLatitudeLabel: 'Latitude',
    inputGeoLongitudeLabel: 'Longitude',
    questionGeoConfigSettingText: 'Polygon capture and validation',
    inputGeoAccuracyThresholdLabel: 'GPS accuracy threshold (m)',
    inputGeoAccuracyThresholdTooltip:
      'Points recorded less accurately than this are marked on the map and block submission. Enumerators may tighten this limit on their own device, never loosen it.',
    inputGeoAllowTappingCheckbox: 'Require GPS capture (disable tap-to-draw)',
    inputGeoAllowTappingHint:
      'Mobile app only. Enumerators must stand at each corner instead of tracing the shape on the map; the web form is unaffected.',
    questionGeoRulesSettingText: 'Validation rules',
    geoRuleColumnRule: 'Rule',
    geoRuleColumnLimit: 'Limit',
    geoRuleColumnSeverity: 'On failure',
    geoRuleGroupShape: 'Shape',
    geoRuleGroupArea: 'Area',
    geoRuleGroupOverlap: 'Overlap',
    geoRuleParseable: 'Is a polygon',
    geoRuleMinVertices: 'Minimum points',
    geoRuleSelfIntersection: 'No self-crossing',
    geoRuleMinArea: 'Minimum area',
    geoRuleMaxArea: 'Maximum area',
    geoRuleOverlap: 'No overlap with other answers',
    geoSeverityOff: 'Do not check',
    geoSeverityDefault: 'Use device default',
    geoSeverityBlock: 'Block submission',
    geoSeverityWarn: 'Warn only',
    geoRuleNoLimit: '—',
    geoRuleMinVerticesLimit: '3',
    geoRuleMinAreaLimit: '10 m²',
    inputGeoMaxAreaLabel: 'Maximum area (ha)',
    inputGeoMaxAreaTooltip:
      'Hectares. Leave empty for no upper limit. Catches shapes drawn by tapping a zoomed-out map, which are slow to validate as well as wrong.',
    inputGeoDetectOverlapsCheckbox:
      'Detect overlaps with other answers to this question',
    inputGeoDetectOverlapsHint:
      'Enabling this syncs the geometry of every other response to this question onto the device.',
    inputGeoTappingBypassHint:
      'Overlap detection alone does not stop an enumerator deleting a shape and redrawing it by tapping. A tapped shape records no accuracy, so no accuracy limit can reject it. Tick "Require GPS capture" above to close this.',
    inputGeoOverlapThresholdLabel: 'Maximum overlap (%)',
    inputGeoOverlapThresholdTooltip:
      'The most overlap ever tolerated. The limit actually applied is derived from the GPS accuracy of both shapes and is never looser than this.',
    inputGeoOverlapThresholdFloorLabel: 'Minimum overlap (%)',
    inputGeoOverlapThresholdFloorTooltip:
      'The least overlap that can ever be reported. Stops large, accurately measured shapes flagging on a sliver of GPS noise.',
    questionMoreAttachmentSettingText: 'More Attachment Question Setting',
    inputAllowedFileTypesLabel: 'Allowed File Types',
    inputAttachmentEndpointLabel: 'Attachment Endpoint',
    inputAttachmentResponseKeyLabel: 'Attachment Response Key',
    inputEntityConfigToggleCheckbox: 'Enable Entity Config',
    inputEntityNameLabel: 'Entity Name',
    inputEntityParentIdLabel: 'Entity Parent ID',
    inputPartialRequiredCheckbox: 'Partial Required',
    inputCheckStrategyLabel: 'Check Strategy',
    inputExpandAllCheckbox: 'Expand All',
    autoSaveStatusSaved: 'All changes saved',
    autoSaveStatusDirty: 'Unsaved changes',
    autoSaveStatusSaving: 'Saving changes...',
    autoSaveStatusError: 'Auto-save failed. Click to retry',
    autoSaveLastSavedAt: 'Saved at',
    autoSaveDraftRecovered: 'Draft restored from local cache',
  },
};

export default UIStaticText;
